module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e476"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }, [_c('a', {
    attrs: {
      "id": "c1"
    }
  }, [_c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e477"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e479"
    }
  }, [_c('b', [_c('i', [_vm._v("B")])]), _vm._v("eing a busy stay-at-home mom, I found it an enormous challenge to write a book (it's hard enough just finding the time to even read one). But, thanks to some incredible people, the task was completed and a dream was fulfilled. Because of this, I want to take a moment to thank them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e483"
    }
  }, [_vm._v("First and foremost, thank you to my wonderful husband, Jeff. There would never have even been a book without your overwhelming love, incredible support, and fertile reproductive system.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e485"
    }
  }, [_vm._v("To my editor, Kate Epstein, I'm forever grateful that you pulled my proposal out from your towering slush pile, and took a chance with it and me. This book is much better thanks to your creative ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e487"
    }
  }, [_vm._v("To Dr. Sandy Tisherman. I'm so glad that you agreed to share your medical advice and pregnancy secrets. You're an amazing doctor and approve so many more medications than I was allowed, that I almost wish that I were pregnant again. Almost.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e489"
    }
  }, [_vm._v("And thanks to my mom for taking my daughter out every Wednesday so that I could work, even when she was cranky (my daughter, not my mom). Without your help, I'd still be on the table of contents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e491"
    }
  }, [_vm._v("And thanks to my dad, for telling me as a child that I had talent to write. It makes it easier to believe in yourself when someone you love believes in you first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e493"
    }
  }, [_vm._v("I'm also indebted to Nurse Sharron, my family, friends, and even complete strangers, who generously contributed their advice and pregnancy suckage stories for all to share and enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e495"
    }
  }, [_vm._v("And finally, a big thanks to Po, my daughter's favorite Teletubbie, for keeping her entertained while Mommy had a deadline.")])])])]), _c('a', {
    attrs: {
      "id": "c1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b52acc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kime_9781440501951_epub_c1.vue
// module id = 75
// module chunks = 0